var translation = {
	Navatar: {
		header: "AWS 프로필",
		subheader: "프로필을 통해 일부 AWS 경험과의 상호 작용을 개선할 수 있습니다.",
		profileButtonText: "프로필 보기",
		logOutText: "로그아웃",
		logInText: "로그인",
		createProfileText: "프로필 생성",
		federateLoginModalTitle: "Midway를 사용하여 AWS 프로필에 액세스",
		federateLoginModalFirstDescription: "Amazon 직원은 Midway를 사용하여 AWS 프로필에 액세스할 것을 권장합니다. 이 보안 권장 방법은 내부 시스템과의 원활한 통합을 제공합니다.",
		federateLoginModalSecondDescription: "AWS Builder ID를 사용하여 Amazon 이메일 주소로 로그인했기 때문에 이 메시지가 표시되었습니다. 이 메시지는 Midway로 전환하거나 현재 로그인 방법을 계속 사용하도록 선택할 때까지 로그인할 때마다 나타납니다.",
		federateLoginModalPrimaryButton: "Midway로 로그인",
		federateLoginModalSecondaryButton: "AWS Builder ID 계속 사용"
	}
};
var Navatar = {
	translation: translation
};

export { Navatar as default, translation };
